export const COURSES = "courses";
export const ARTICLES = "articles";
export const VIDEOS = "videos";
export const EDITORIALS = "editorials";
export const APP = "app";
export const VIEW_SLIDER = "viewSlider";
export const CONTACT = "contact";
export const TEAM = "team";
export const MEMBERS = "members";
